import { render } from "./AddValueCompanySetting.vue?vue&type=template&id=13358d68"
import script from "./AddValueCompanySetting.vue?vue&type=script&lang=js"
export * from "./AddValueCompanySetting.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__